export const validateWeb = (url: string) => {
  const urlRegex =
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})(\/[^\s]*)?$/;

  return urlRegex.test(url);
};
